import React from 'react'
import styles from './Embed.module.css'

export const Embed = ({ url, width = '100%', height = '500px' }: { url: string; width?: string; height?: string }) => {
    return <iframe src={url} width={width} height={height} className={styles.iframe} title="Embedded URL" />
}
